import { withRouter } from 'next/router';
import React from 'react';
import dynamic from 'next/dynamic'
import ArabicPage from '../components/static/arabicPage';
const Layout = dynamic(() => import('../hoc/staticLayout'), { loading: () => <></>, ssr: true });
import { getArabicData } from "../api/arabic";

const Arabic = (props) => {
    const meta = {
		title: "Arabic | Arabic Language | Bayan",
		description: "Courses for All Degree Plans, Islamic Leadership and Spirituality only allowed to replace Islamic Ethics for Islamic Leadership students.",
		route: "arabic",
	}
    return ( 
        <Layout theme={props.theme} meta={meta}>
            <ArabicPage arabicData={props?.arabicData}/>
        </Layout>
     );
}
export async function getServerSideProps(ctx) {
    const arabicData = await getArabicData();
    // console.log(arabicData);
    return { props: { arabicData: arabicData } }
}
export default withRouter(Arabic);
